export enum StatusEmailEnum {
  Enviado = 1,
  Erro = 2,
  Pendente = 3
}
